import 'css-chunksrc/feature/provision/EnterToken.module.scss';export default {
  "input-title": "EnterToken_input-title",
  "form": "EnterToken_form",
  "input": "EnterToken_input"
};